<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #334155 0%, #475569 100%);">
            <i class="fa fa-calculator text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Custo Operacional (Template)</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Gestão de templates de custos da produção</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2 flex-wrap">
            <b-button-group class="mr-2 d-none d-lg-inline-flex">
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.hover title="Limpar filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-2 form-search-wrapper">
              <b-form-input
                v-model="textoPesquisa"
                placeholder="Buscar por descrição..."
                class="border-0 bg-transparent shadow-xs"
                style="font-size: 0.9rem;"
                @keydown.enter.native="pesquisar">
              </b-form-input>
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar">
              <i class="fa fa-search mr-1"></i>
              <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>

          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo">
            <i class="fa fa-plus-circle mr-1"></i>
            <span class="d-none d-sm-inline">Novo Template</span>
          </b-button>
        </div>
      </div>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="mb-0 table-finance"
              primary-key="ID"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              show-empty
              empty-text="Nenhum registro encontrado"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              @row-dblclicked="edit"
            >
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter label="Descrição" v-model="filtros.DESCRICAO" :options="opcoes.DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="excluir(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td colspan="3" class="text-left bg-light py-2 px-3">
                    <span class="text-muted small font-weight-bold">Total de registros: {{ itensFiltrados.length }}</span>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import Tools from '@/tools/tools.js'

export default {
  components: {
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: false,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' }
    ]
  })],
  data () {
    return {
      isBusy: false,
      textoPesquisa: '',
      lista: [],
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class: 'align-middle text-center', thStyle: { width: '80px' } },
        { key: 'DESCRICAO', label: 'Descrição (Template)', sortable: true, class: 'align-middle' },
        { key: 'actions', label: 'Ações', class: 'align-middle text-center', thStyle: { width: '120px' } }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  },
  methods: {
    async pesquisar() {
      this.isBusy = true
      try {
        const response = await this.$http.post('/api/protected/custo-operacional/pesquisar', { nomePesquisa: this.textoPesquisa })
        this.lista = response.data || []
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro inesperado')
      } finally {
        this.isBusy = false
      }
    },
    limparFiltro() {
      this.textoPesquisa = ''
      this.pesquisar()
    },
    novo () { 
      this.$router.push(`/cadastros/custo-operacional/add`) 
    },
    edit (item) {
      this.$router.push(`/cadastros/custo-operacional/edit/${item.ID}`)
    },
    excluir(item) {
      this.$bvModal.msgBoxConfirm(`Deseja realmente excluir o template "${item.DESCRICAO}"?`, {
        title: 'Confirmar Exclusão',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if (value) {
          this.$http.delete(`/api/protected/custo-operacional/delete/${item.ID}`)
            .then(() => {
                Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Template excluído com sucesso!')
                this.pesquisar(); 
            })
            .catch(err => {
              console.error(err);
              Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || 'Erro ao excluir template.')
            });
        }
      })
      .catch(() => {});
    }
  },
  mounted() {
    this.pesquisar()
  }
}
</script>

<style scoped>
.list-header-premium { background: #fff; border-bottom: 1px solid #e2e8f0; }
.header-icon-wrapper { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; border-radius: 12px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); }
.header-icon-wrapper i { font-size: 1.5rem; }
.custom-input-premium { border: 1px solid #e2e8f0; border-radius: 8px; padding: 0.5rem 0.75rem; transition: all 0.2s; }
.custom-input-premium:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); outline: none; }
.table-finance { font-size: 0.8rem !important; }
.table-finance >>> thead th { background-color: #f8fafc !important; text-transform: uppercase; font-size: 0.7rem !important; letter-spacing: 0.05em; color: #64748b; border-top: none; border-bottom: 2px solid #e2e8f0 !important; padding: 0.4rem 0.75rem !important; position: sticky !important; top: 0; z-index: 20 !important; box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.05); }
.table-finance >>> tbody td { padding: 0.2rem 0.75rem !important; vertical-align: middle; border-bottom: 1px solid #f1f5f9; }
.btn-icon-only { width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center; }
.btn-soft-primary { background: #eff6ff; color: #3b82f6; border: none; }
.btn-soft-primary:hover { background: #dbeafe; color: #2563eb; }
.btn-soft-danger { background: #fef2f2; color: #ef4444; border: none; }
.btn-soft-danger:hover { background: #fee2e2; color: #dc2626; }
.shadow-xs { box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); }
.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }
.form-search-wrapper { min-width: 280px; }
@media (max-width: 991px) {
  .search-pill-responsive { flex-wrap: wrap; border-radius: 1rem !important; padding: 0.5rem !important; }
  .search-pill-responsive .px-2 { width: 100%; margin-bottom: 0.5rem; }
  .search-pill-responsive .btn-primary { width: 100%; }
  .form-search-wrapper { min-width: 100%; border-left: 0 !important; margin-right: 0 !important; padding: 0.5rem 0 !important; }
}
@media (max-width: 767px) {
  .list-header-premium { gap: 0.5rem !important; padding-bottom: 1rem !important; }
  .list-header-premium .p-3 { padding: 0.75rem !important; }
  .search-pill-responsive { width: 100%; margin-right: 0 !important; border-radius: 1.5rem !important; }
  .btn-adicionar-responsive { width: 100%; margin-top: 0.5rem; }
}
@media (max-width: 575px) {
  .header-icon-wrapper { width: 38px; height: 38px; }
  .header-text-container h4 { font-size: 1rem !important; }
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/custo-operacional/CentroCustoOpListagem.vue